export const hideSwatchDropdown = () => {
  const swatchList = document.querySelector('.swatch-list');
  const filterArrow = document.querySelector('.dropdown__filter-arrow');

  if (swatchList && !swatchList.classList.contains('hide')) {
    swatchList.classList.add('hide');
  }

  if (filterArrow?.classList.contains('rotate')) {
    filterArrow.classList.remove('rotate');
  }
};

function swatchSelector() {
  const $filterSelected = $('.dropdown__filter-selected');
  const $swatchList = $('ul.swatch-list');

  if (!$filterSelected.length || !$swatchList.length) return;

  const $filterArrow = $('.dropdown__filter-arrow');

  $filterSelected.on('click', (e) => {
    e.preventDefault();
    $swatchList.toggleClass('hide');
    $filterArrow.toggleClass('rotate');
  });
}

export default swatchSelector;
